import clsx from 'clsx';

export default function NewsLetter() {
  return (
    <>
      <div id="mc_embed_signup">
        <form
          action="https://safeback.us13.list-manage.com/subscribe/post?u=ba421af5a920e1602ebfe4a2f&amp;id=512a145d9f&amp;f_id=00d19fe2f0"
          method="post"
          id="mc-embedded-subscribe-form"
          name="mc-embedded-subscribe-form"
          className="validate"
          target="_blank"
          noValidate
        >
          <div
            id="mc_embed_signup_scroll"
            className={clsx(
              'grid grid-cols-6 gap-y-4', //
              'md:my-8 md:flex md:space-x-4', //
            )}
          >
            <div className={'col-span-6'}>Subscribe to our newsletter </div>

            <input
              type="email"
              name="EMAIL"
              placeholder={'Your email'}
              className={clsx(
                'col-span-4 border-b border-white bg-white bg-transparent outline-none',
                'md:w-64',
              )}
              id="mce-EMAIL"
              required
            />

            <input
              type="submit"
              value="Subscribe"
              name="subscribe"
              id="mc-embedded-subscribe"
              className={clsx('col-span-2 border-none')}
            />
          </div>
        </form>
      </div>
    </>
  );
}
